// extracted by mini-css-extract-plugin
module.exports = {"List":"ProductLinkList_List__z6IrJ"};